import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _DarhboardAltLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("rect", { width: 6, height: 7, x: 4, y: 4, stroke: "currentColor", strokeLinejoin: "round", rx: 1 }),
            React.createElement("rect", { width: 6, height: 5, x: 4, y: 15, stroke: "currentColor", strokeLinejoin: "round", rx: 1 }),
            React.createElement("rect", { width: 6, height: 5, x: 14, y: 4, stroke: "currentColor", strokeLinejoin: "round", rx: 1 }),
            React.createElement("rect", { width: 6, height: 7, x: 14, y: 13, stroke: "currentColor", strokeLinejoin: "round", rx: 1 })));
}
const DarhboardAltLight = forwardRef(_DarhboardAltLight);
export { DarhboardAltLight };
